<template>
    <div>
        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div v-else>
            <div class="d-flex justify-content-between align-items-center" style="flex-wrap: wrap;">
                <div class="d-flex align-items-center" style="flex-wrap: wrap;">
                    <el-radio-group class="mt-2" v-model="type" @input="handleChangeType">
                        <el-radio-button label="all">All</el-radio-button>
                        <el-radio-button label="accepted">Accepted</el-radio-button>
                        <el-radio-button label="denied">Denied</el-radio-button>
                        <el-radio-button label="errors">Errors</el-radio-button>
                    </el-radio-group>
                    <!-- <el-input
                        v-model="filters.name"
                        @keyup.native="filter(true)"
                        style="width: 300px"
                        class="ml-1"
                        placeholder="Filter by name"/> -->
                    <el-input
                        v-model="filters.registrationNumber"
                        @keydown.enter.native="filter()"
                        style="width: 300px"
                        class="ml-1"
                        placeholder="Filter by registration number"/>
                    <el-button
                        class="ml-1 btn btn-primary"
                        @click="filter()">
                        Filter
                    </el-button>
                    <el-button
                        v-if="filterOn"
                        @click="filters.registrationNumber = ''; getData(); filterOn = false"
                        style="background-color: #25a5f5 !important; color: #fff !important;"
                        class="mt-1"
                    >
                        Clear Filter&nbsp; <fa icon="times" />
                    </el-button>
                </div>

                <div>
                    <el-select class="mr-4" name="perpage" id="perpage" v-model="perPage" @change="getData" size="large" placeholder="Select">
                        <!-- <template slot="props">
                            <span>{{ perPage }} Per Page</span>
                        </template> -->
                        <el-option label="10 Per Page" :value="10"></el-option>
                        <el-option label="25 Per Page" :value="25"></el-option>
                        <el-option label="50 Per Page" :value="50"></el-option>
                        <el-option label="100 Per Page" :value="100"></el-option>
                        <el-option label="200 Per Page" :value="200"></el-option>
                        <el-option label="250 Per Page" :value="250"></el-option>
                        <el-option label="300 Per Page" :value="300"></el-option>
                        <el-option label="500 Per Page" :value="500"></el-option>
                        <el-option label="1000 Per Page" :value="1000"></el-option>
                        <el-option label="1250 Per Page" :value="1250"></el-option>
                    </el-select>
                    <el-button  v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].downloadReports))"
                        :loading="downloadingAttendees"
                        @click="downloadAttendees(attendees[type])">
                            <fa icon="download"/>
                    </el-button>
                    <el-button  v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].downloadReports))"
                        :loading="downloadingAttendeesFromScreen"
                        @click="downloadAttendeesFromScreen(attendees[type])">
                            Download As Shown
                    </el-button>
                </div>
            </div>

            <card>
                <el-table
                    v-if="type === 'errors'"
                    :data="attendees.errors">
                        <el-table-column label="Registration Number">
                            <template slot-scope="props">
                                {{ props.row.registration.confirmationNumber }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Name">
                            <template slot-scope="props">
                                {{ props.row.registration  | fullName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="E-Mail">
                            <template slot-scope="props">
                                {{ props.row.registration | email }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Scanned At">
                            <template slot-scope="props">
                                {{ props.row.createdAt | formatDate }}
                            </template>
                        </el-table-column>
                        <el-table-column label="By">
                            <template slot-scope="props">
                                <span v-if="props.row.by">
                                    {{ props.row.by.email }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="Description">
                            <template slot-scope="props">
                                <span v-if="props.row.description">
                                    {{ props.row.description }}
                                </span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Reason">
                            <template slot-scope="props">
                                <span v-if="props.row.reason">
                                    {{ props.row.reason }}
                                </span>
                            </template>
                        </el-table-column>
                </el-table>

                <el-table
                    v-else
                    :data="attendees[type]">
                        <el-table-column label="Registration Number">
                            <template slot-scope="props">
                                {{ props.row.confirmationNumber }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Name">
                            <template slot-scope="props">
                                {{ props.row  | fullName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="E-Mail">
                            <template slot-scope="props">
                                {{ props.row | email }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="type !== 'all' ? 'Checked in At' : 'Registered At'">
                            <template slot-scope="props">
                                <span v-if="type !== 'all'">
                                    <span v-if="props.row.checkinDate">
                                        {{ props.row.checkinDate | formatDate }}
                                    </span>
                                    <span v-else></span>
                                </span>
                                <span v-else>
                                    {{ props.row.createdAt | formatDate }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="type !== 'all'"
                            label="Method">
                                <template slot-scope="props">
                                    <span v-if="props.row.checkinMethod">
                                        {{ props.row.checkinMethod }}
                                    </span>
                                </template>
                        </el-table-column>
                        <el-table-column
                            v-if="type !== 'all'"
                            label="By">
                                <template slot-scope="props">
                                    <span v-if="props.row.checkinBy">
                                        {{ props.row.checkinBy }}
                                    </span>
                                </template>
                        </el-table-column>
                        <el-table-column label="Actions" v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].checkinActivities))">
                            <template slot-scope="props">
                                <div v-if="type === 'all' && !props.row.checkedIn">
                                    <el-button
                                        :loading="checkinLoading"
                                        size="mini"
                                        class="mr-1"
                                        @click="checkin(props.$index, props.row, true, 'manual')">
                                        Checkin
                                    </el-button>
                                    <!-- <el-button
                                        size="mini"
                                        class="mr-1"
                                        @click="checkin(props.$index, props.row, false, 'manual')">
                                            Deny
                                    </el-button> -->
                                </div>
                                <router-link :to="{ name: 'attendee', params: { registrationId: props.row._id } }">
                                    <el-button size="mini">
                                        Details
                                    </el-button>
                                </router-link>
                            </template>
                        </el-table-column>
                </el-table>
            </card>
            <div v-if="total" class="row">
                <div class="col-12 d-flex justify-content-end">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :current-page.sync="page"
                        :total="total"
                        :page-size="perPage"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../http.js'
import download from 'downloadjs'
import moment from 'moment'
import _, { template } from 'lodash'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            loading: false,
            downloadingAttendees: false,
            downloadingAttendeesFromScreen: false,
            activityId: this.$route.params.activityId,
            type: 'all',
            attendees: {
                data: [],
                all: [],
                denied: [],
                accepted: [],
                errors: []
            },
            filters: {
                name: '',
                confirmationNumber: ''
            },
            checkinData: {
                checkins: [],
                checkinErrors:[]
            },
            total: 1000,
            page: 1,
            perPage: 25,
            filterOn: false,
            checkinLoading: false,
            activity: null
        }
    },
    computed: {
        ...mapState([
            'user',
            'activities'
        ])
    },
    mounted () {
        if (this.$route.query.checkins) {
            this.type = 'accepted'
        }

        this.getData()

        if(!this.activities.length){
            this.$store.dispatch("getAll", {
                path: "activities",
                params: {
                    filters: { eventId: this.$route.params.eventId }
                }
            })
        }

        this.activity = this.activities.find(activity => activity._id === this.activityId)
        
    },
    watch:{
        page: "getData",
        type(){
            this.loading = true;
            let timer = setTimeout(()=>{
                this.loading = false
                clearTimeout(timer)
            }, 500)
        }
    },
    methods: {
        handleChangeType(){
            this.page = 1;
            this.getData();
            
        },
        getData: async function () {
            this.loading = true
            try {
                const res = await http.post(`/api/activities/${this.activityId}/attendees?page=${this.page}&perPage=${this.perPage}`, {
                    eventId: this.$route.params.eventId,
                    type: this.type
                }, {
                    params: {
                        filters: {
                            // name: this.filters.name,
                            registrationNumber: this.filters.registrationNumber
                        }
                    }
                })
                this.attendees[this.type] = res.data.attendees
                this.total = res.data.total
                

            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
            this.loading = false
        },
        getRegistrationName: function (registration) {
            let firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            firstName = firstName ? firstName.value : ''

            let lastName = registration.fields.find(field => field.fieldMapping === 'lastName')
            lastName = lastName ? lastName.value : ''

            return firstName + ' ' + lastName
        },
        downloadAttendees: async function (attendees) {
            this.downloadingAttendees = true
            let registrationIds = attendees.map(attendee => attendee._id)

            // download errored list
            if (attendees[0] && attendees[0].registration) {
                registrationIds = attendees.map(attendee => attendee.registration._id)
            }

            try {
                const response = await http.post('/api/registrations/download', { registrationIds }, {
                    responseType: 'arraybuffer'
                })                
                download(response.data, 'activity-' + this.activity.name + '-' + this.type + '-attendees.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading activity attendees')
            }
            this.downloadingAttendees = false
        },
        downloadAttendeesFromScreen: async function (attendees) {            
            let data = []
            let fields = []
            if(this.type == 'all'){
                fields = [ 'Registration Number', 'Name', 'E-Mail', 'Registered At' ]
                attendees.forEach(attendee => {
                    const emailMap = attendee.fields.find(field => field.fieldMapping === 'email')
                    let email = emailMap ? emailMap.value : ''
                    const name = this.getRegistrationName(attendee)
                    let date = moment(attendee.createdAt).format('YYYY-MM-DD HH:mm:ss')
                    data.push([attendee.confirmationNumber, name, email, date])
                })
            }
            else if(this.type == 'errors'){
                fields = [ 'Registration Number', 'Name', 'E-Mail', 'Scanned At', 'By', 'Reason' ]
                attendees.forEach(attendee => {
                    const mapping = attendee.registration.fields.find(field => field.fieldMapping === 'email')
                    let email = mapping ? mapping.value : ''
                    const name = this.getRegistrationName(attendee.registration)
                    let date = moment(attendee.createdAt).format('YYYY-MM-DD HH:mm:ss')
                    data.push([attendee.registration.confirmationNumber, name, email, date, attendee.by ? attendee.by.email : '', attendee.reason ? attendee.reason : ''])
                })

            }
            else{
                fields = [ 'Registration Number', 'Name', 'E-Mail', 'Checked in At' , 'Method', 'By' ]
                attendees.forEach(attendee => {
                    const mapping = attendee.fields.find(field => field.fieldMapping === 'email')
                    let email = mapping ? mapping.value : ''
                    let date = attendee.checkinDate ? moment(attendee.checkinDate).format('YYYY-MM-DD HH:mm:ss') : ''
                    let method = attendee.checkinMethod ? attendee.checkinMethod : ''
                    let by = attendee.checkinBy ? attendee.checkinBy : ''
                    const name = this.getRegistrationName(attendee)
                    data.push([attendee.confirmationNumber, name, email, date, method, by])
                })
            }

            this.downloadingAttendeesFromScreen = true
            try {
                const response = await http.post('/api/registrations/download-from-screen', { fields, data }, {
                    responseType: 'arraybuffer'
                })
                download(response.data, 'activity-' + this.activity.name + '-' + this.type + '-screen-attendees.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading activity attendees')
            }
            this.downloadingAttendeesFromScreen = false
        },
        checkin: async function (index, registration, accept, method) {
            this.checkinLoading = true
            try {
                await this.$store.dispatch('checkin', {
                    type: 'activity',
                    id: this.activityId,
                    registrationId: registration._id,
                    accept,
                    method
                })
                this.$notify("Checked in successfully")
                registration.checkedIn = true

            } catch (e) {
                console.log(e)
                console.log('error checking in')
            }
            this.checkinLoading = false
        },
        filter: function () {
            this.getData()
            this.filterOn = true
        }
    },
    filters: {
        formatDate: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
        email: (registration) => {
            let email = ''
            const mapping = registration.fields.find(field => field.fieldMapping === 'email')
            if (mapping) {
                email = mapping.value
            }
            
            return email
        },
        fullName: (registration) => {         
            let firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            firstName = firstName ? firstName.value : ''

            let lastName = registration.fields.find(field => field.fieldMapping === 'lastName')
            lastName = lastName ? lastName.value : ''

            return firstName + ' ' + lastName
        },
    }
}
</script>